import Image from 'next/image';
import { cn } from '@/lib/utils';

interface SliderThumbnailItemProps {
  itemActive: number;
  id: number;
  image: string;
  name: string;
  onClick: () => void;
  isFirst: boolean;
}

const SliderThumbnailItem = ({
  itemActive,
  id,
  image,
  name,
  onClick,
  isFirst,
}: SliderThumbnailItemProps) => {
  const getItemStyle = () => {
    if (isFirst) {
      return {
        width: '200px',
        brightness: 'brightness-150',
        textStyle: 'font-bold'
      };
    } else {
      const position = Math.abs(id - itemActive);
      return {
        width: `${Math.max(180 - position * 20, 100)}px`,
        brightness: `brightness-${Math.max(100 - position * 25, 50)}`,
        textStyle: 'font-normal'
      };
    }
  };

  const style = getItemStyle();

  return (
    <li
      role="button"
      onClick={onClick}
      className={cn(
        'h-[250px] shrink-0 transition-all duration-300 overflow-hidden relative after:absolute after:w-full after:h-full after:left-0 after:bottom-0 after:bg-thumbnails hover:brightness-150',
        style.brightness
      )}
      style={{ width: style.width }}
    >
      <div className="relative w-full h-full rounded-lg">
        <Image
          src={image}
          alt={name}
          fill
          className="object-cover rounded-lg"
          priority={isFirst || id === itemActive}
        />
      </div>
      <div
        className={cn(
          'absolute top-auto right-[10px] bottom-[20px] left-[10px] z-10 translate-y-[30px] blur-[20px] opacity-0 animation-delay-75',
          (isFirst || id === itemActive) && 'animate-show-content'
        )}
      >
        <h2 className={cn('line-clamp-1 text-start text-white', style.textStyle)}>
          {name}
        </h2>
      </div>
    </li>
  );
};

export default SliderThumbnailItem;